import React from 'react';

import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';
import { OrderImportCardFooterComplete } from './order-import-card-footer-complete';
import { OrderImportCardFooterIncomplete } from './order-import-card-footer-incomplete';

export const OrderImportCardFooter = () => {
  const { isOrderImportComplete } = useHomePageOnboardContext();
  return isOrderImportComplete ? (
    <OrderImportCardFooterComplete />
  ) : (
    <>
      <OrderImportCardFooterIncomplete />
    </>
  );
};
